import { createUserExtensionF } from './createUserExtensionF'

// order doesnt matter
export const adminFlows = [
  createUserExtensionF,
]
